import React from 'react';
import {Grid, Skeleton} from '@mui/material';
import {Card} from "react-bootstrap";
import {InputSuspense, LabelSuspense} from "_components/suspense/parts";

interface FormSuspenseProps {
    fields: number;
}

const FormSuspense: React.FC<FormSuspenseProps> = ({fields}) => {
    return (
        <Card className='w-100'>
            <Card.Body>
                <Grid container spacing={2}>
                    {Array.from({length: fields}).map((_, index) => (
                        <Grid item xs={12} key={index}>
                            <LabelSuspense/>
                            <InputSuspense/>
                        </Grid>
                    ))}
                </Grid>
            </Card.Body>

            <Card.Footer>
                <div className='d-flex justify-content-end gap-3'>
                    <Skeleton variant="rectangular" width={150} height={40}/>
                    <Skeleton variant="rectangular" width={150} height={40}/>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default FormSuspense;
